var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/material';
export var makeButtonStateLayer = function (layerColor) { return ({
    '&:hover, &:active': {
        '&:after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            height: '100%',
            borderRadius: 'inherit',
            top: 0,
            left: 0,
            right: 0,
        },
    },
    '&:hover:after': {
        backgroundColor: alpha(layerColor, 0.08),
    },
    '&:active:after': {
        backgroundColor: alpha(layerColor, 0.12),
    },
}); };
export var filled = {
    opacity: 1,
    color: 'primary.contrastText',
    svg: {
        width: '18px',
        height: '18px',
    },
    textTransform: 'unset',
    '&:disabled': {
        backgroundColor: function (theme) {
            return alpha(theme.palette.common.black, 0.1);
        },
        '& svg': {
            opacity: 0.38,
        },
    },
};
export var outlined = {
    opacity: 1,
    color: 'primary.main',
    border: 'solid 1px',
    borderColor: 'outline.main',
    svg: {
        width: '18px',
        height: '18px',
    },
    textTransform: 'unset',
    '&:disabled': {
        border: 'solid 1px',
        borderColor: function (theme) { return alpha(theme.palette.background.paper, 0.12); },
        backgroundColor: 'unset',
        '& svg': {
            opacity: 0.38,
        },
    },
};
export var text = {
    opacity: 1,
    color: 'primary.main',
    svg: {
        width: '18px',
        height: '18px',
    },
    textTransform: 'unset',
    '&:not(:disabled)': function (theme) { return (__assign(__assign({}, makeButtonStateLayer(theme.palette.primary.main)), { backgroundColor: 'unset' })); },
    '&:disabled': {
        backgroundColor: 'unset',
        '& svg': {
            opacity: 0.38,
        },
    },
};
export var elevated = {
    opacity: 1,
    color: 'primary.main',
    backgroundColor: 'background.paper',
    svg: {
        width: '18px',
        height: '18px',
    },
    textTransform: 'unset',
    '&:not(:disabled)': function (theme) { return (__assign(__assign({}, makeButtonStateLayer(theme.palette.primary.main)), { boxShadow: theme.elevations[1], '&:hover': {
            boxShadow: theme.elevations[2],
        }, '&:active': {
            boxShadow: theme.elevations[3],
        }, backgroundColor: 'unset' })); },
    '&:disabled': {
        color: 'surface.contrastText',
        opacity: 0.38,
        '&:after': {
            backgroundColor: function (theme) {
                return alpha(theme.palette.background.paper, 0.12);
            },
            content: '""',
            display: 'block',
            position: 'absolute',
            height: '100%',
            borderRadius: 'inherit',
            top: 0,
            left: 0,
            right: 0,
        },
        '& svg': {
            opacity: 0.38,
        },
    },
};
export var tonal = {
    opacity: 1,
    color: 'secondary.contrastText',
    svg: {
        width: '18px',
        height: '18px',
    },
    textTransform: 'unset',
    '&:not(:disabled)': function (theme) { return (__assign(__assign({}, makeButtonStateLayer(theme.palette.primary.main)), { '&:hover:not(:active)': {
            boxShadow: theme.elevations[1],
        }, backgroundColor: 'secondary.main' })); },
    '&:disabled': {
        color: 'surface.contrastText',
        opacity: 0.38,
        '&:after': {
            backgroundColor: function (theme) {
                return alpha(theme.palette.background.paper, 0.12);
            },
            content: '""',
            display: 'block',
            position: 'absolute',
            height: '100%',
            borderRadius: 'inherit',
            top: 0,
            left: 0,
            right: 0,
        },
        '& svg': {
            opacity: 0.38,
        },
    },
};
